<panel>
  <h1>{{ 'price-adjustments.header' | translate }}</h1>

  @if (priceAdjustments) {
    <list-view scrollable>
      <header>{{ 'price-adjustments.setup-name' | translate }}</header>
      <header defaultSort="descending">{{ 'price-adjustments.adjustment-count' | translate }}</header>
      <header>{{ 'price-adjustments.status' | translate }}</header>
      <row *listData="let priceAdjustment from priceAdjustments" (action)="select(priceAdjustment);">
        <column>{{ priceAdjustment.accountingPlanSetups[0].name }}</column>
        <column>{{ priceAdjustment.priceAdjustmentValues.length }}</column>
        <column>{{ (priceAdjustment.deactivated ? 'price-adjustments.deactivated' : 'price-adjustments.active') | translate }}</column>
      </row>
    </list-view>
  }
</panel>

@if (selectedAdjustment) {
  <panel>
    <h1>{{ 'price-adjustments.edit-header' | translate: { name: selectedAdjustment.accountingPlanSetups[0].name } }}</h1>
    <section>
      <custom-input [label]="'price-adjustments.active' | translate" [inputType]="inputType.Switch" [value]="!selectedAdjustment.deactivated" (valueChange)="selectedAdjustment.deactivated = !$event" />
      <custom-input [label]="'price-adjustments.annual-adjustment-percent' | translate" [inputType]="inputType.Percentage" [(value)]="selectedAdjustment.annualAdjustmentPercent" />
    </section>
    <list-view scrollable>
      <header align-right>{{ 'price-adjustments.intervals' | translate }}</header>
      <row *listData="let interval from sortedIntervals">
        <column align-right>
        @if (interval.lowerBound === interval.value.upperBound) {
          {{ 'price-adjustments.value-equals' | translate }}
        }
        @if (interval.lowerBound !== interval.value.upperBound) {
          {{ 'price-adjustments.value-less-or-equal' | translate: { lowerValue: interval.lowerBound } }}
        }
        <input type="number" [(ngModel)]="interval.value.upperBound" (blur)="sortAdjustmentIntervals()" />
        = <input type="number" [(ngModel)]="interval.value.targetValue" />
      </column>
      <menu always-visible [visibleMenuButton]="false">
        <menuitem (click)="removeValue(interval.value, selectedAdjustment.priceAdjustmentValues)"><icon small type="trash" /></menuitem>
      </menu>
    </row>
  </list-view>
  <section>
    <button [ignoreValidation]="true" [loader]="false" (click)="addNewValue(selectedAdjustment.priceAdjustmentValues)"><icon type="plus" />{{ 'price-adjustments.add-value' | translate }}</button>
  </section>
  <section>
    <button [ignoreValidation]="true" (click)="save()" [label]="'general.save' | translate"></button>
  </section>
</panel>
}
